"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assetMapper = require("../../../../../lib/assetMapper");

var _default = function _default(_ref) {
  var media = _ref.media,
      href = _ref.href,
      isInHero = _ref.isInHero,
      coverWidth = _ref.coverWidth,
      coverHeight = _ref.coverHeight,
      creatorText = _ref.creatorText;
  return "\n<div class=\"CoverImageContainer\">\n<a class=\"CoverImageContainer noCoverAvailable ".concat(isInHero ? 'secondary-background' : 'primary-background', "\"\n    href=\"").concat(href, "\"\n    tabindex=\"-1\"\n    data-href    =\"").concat(href, "\"\n    data-media-id=\"").concat(media.id, "\"\n    data-title   =\"").concat(media.title, "\"\n    data-type    =\"").concat(media.type.id, "\">\n        <div class=\"title ").concat(isInHero ? 'secondary-font-highlight-box' : 'primary-font primary-font-highlight-box', "\">").concat(media.title, "</div>\n        <div class=\"author ").concat(isInHero ? '' : 'primary-font', "\">").concat(creatorText, "</div>\n\n        <img\n            tabindex=\"-1\"\n            aria-label=\"").concat(media.title, " - ").concat(html(media.type.id), "\"\n            tabindex=\"0\"\n            class=\"large-title js-details-cover-image\"\n            src=\"").concat((0, _assetMapper.toStaticUrl)('img/clear.gif'), "\"\n            alt=\"").concat(media.title, " - ").concat(html(media.type.id), "\"\n            />\n\n</a>\n</div>\n\n");
};

exports["default"] = _default;